module.exports = __webpack_public_path__ + "static/media/Australia.d4212a06.png";